/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Linux_Rpm_TitleInputs */

const en_pc_dl_file_linux_rpm_title = /** @type {(inputs: Pc_Dl_File_Linux_Rpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM package (x86_64)`)
};

const zh_pc_dl_file_linux_rpm_title = /** @type {(inputs: Pc_Dl_File_Linux_Rpm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPM 软件包（x86_64）`)
};

/**
* | output |
* | --- |
* | "RPM package (x86_64)" |
*
* @param {Pc_Dl_File_Linux_Rpm_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_linux_rpm_title = /** @type {((inputs?: Pc_Dl_File_Linux_Rpm_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Linux_Rpm_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_linux_rpm_title(inputs)
	return zh_pc_dl_file_linux_rpm_title(inputs)
});
export { pc_dl_file_linux_rpm_title as "pc.dl.file.linux_rpm.title" }